import { render, staticRenderFns } from "./market-view.vue?vue&type=template&id=5fcd628d&scoped=true"
import script from "./market-view.vue?vue&type=script&lang=ts"
export * from "./market-view.vue?vue&type=script&lang=ts"
import style0 from "./market-view.vue?vue&type=style&index=0&id=5fcd628d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd628d",
  null
  
)

export default component.exports